import { Copy, CopyCheck } from "lucide-react"
import React, { useState } from "react"
import { cn } from "../../utils/cn"

interface CopyTextProps {
    value: string
    /** Texto exibido; default = `value`. */
    label?: React.ReactNode
    className?: string
    /** Oculta o ícone de copiar (útil em células estreitas). */
    hideIcon?: boolean
    title?: string
    "aria-label"?: string
}

/**
 * Texto clicável que copia `value` para o clipboard com feedback "COPIADO!".
 * Para o evento de clique (stopPropagation) para poder viver dentro de linhas clicáveis.
 */
const CopyText: React.FC<CopyTextProps> = ({
    value,
    label,
    className,
    hideIcon,
    title,
    "aria-label": ariaLabel,
}) => {
    const [copied, setCopied] = useState(false)

    const handleCopy = async (e: React.MouseEvent) => {
        e.stopPropagation()
        try {
            await navigator.clipboard.writeText(value)
            setCopied(true)
            setTimeout(() => setCopied(false), 1500)
        } catch (err) {
            console.error("Erro ao copiar:", err)
        }
    }

    return (
        <button
            type="button"
            onClick={handleCopy}
            title={title ?? "Clique para copiar"}
            aria-label={ariaLabel}
            className={cn(
                "inline-flex min-w-0 max-w-full items-center gap-1.5 font-mono text-sm font-bold tracking-wider text-primary transition-colors hover:text-primary/80",
                className
            )}
        >
            {(copied || (label ?? value) !== "") && (
                <span className="min-w-0 truncate">
                    {copied ? "COPIADO!" : label ?? value}
                </span>
            )}
            {!hideIcon &&
                (copied ? (
                    <CopyCheck className="shrink-0 text-success-text" size={13} />
                ) : (
                    <Copy className="shrink-0 text-primary/60" size={13} />
                ))}
        </button>
    )
}

export default CopyText
